import { IAction, IAppProgress } from "@/common/interface";
import { SET_APP_PROGRESS } from "../../actionTypes";

const initState: IAppProgress = {};

export default (state = initState, action: IAction): IAppProgress => {
  switch (action.type) {
    case SET_APP_PROGRESS:
      return { ...state, ...action.data };
    default:
      return state;
  }
};
